var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invalid_fields
    ? _c(
        "div",
        { staticClass: "inputPanel inputPanel__error errorBox_common" },
        [
          _c(
            "div",
            {
              staticClass: "inputPanel__errorMsg errorMsg",
              staticStyle: { "margin-bottom": "20px" }
            },
            [
              _vm.invalidFields.email ||
              _vm.invalidFields.contact_phone ||
              _vm.invalidFields.company_name ||
              _vm.invalidFields.name
                ? _c("div", [
                    _vm.invalidFields.email
                      ? _c("h3", { staticStyle: { margin: "0" } }, [
                          _vm._v("Please enter a valid business email address")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invalidFields.contact_phone
                      ? _c("h3", [_vm._v("Please enter a valid phone number")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invalidFields.company_name || _vm.invalidFields.name
                      ? _c("h3", [
                          _vm._v(
                            "Please enter your details above and click Save & Continue"
                          )
                        ])
                      : _vm._e()
                  ])
                : _c("h3", [
                    _vm._v(
                      "Please answer all questions above before progressing"
                    )
                  ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e94344a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94344a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/InvalidFieldsModal.vue
// module id = null
// module chunks = 